import { z } from 'zod'

export const getFormConfig = (translations: (arg0: string) => any) => {
  const t = (key: string) => translations(key)
  const formConfig = {
    id: 'login-form',
    fields: [
      {
        name: 'password',
        label: t('AUTHORIZATION.RESET_PASSWORD.PASSWORD.LABEL'),
        placeholder: t('AUTHORIZATION.RESET_PASSWORD.PASSWORD.PLACEHOLDER'),
        type: 'password',
        required: true
      },
      {
        name: 'confirm_password',
        label: t('AUTHORIZATION.RESET_PASSWORD.CONFIRM_PASSWORD.LABEL'),
        placeholder: t(
          'AUTHORIZATION.RESET_PASSWORD.CONFIRM_PASSWORD.PLACEHOLDER'
        ),
        type: 'password',
        required: true
      }
    ],
    validationSchema: z
      .object({
        password: z
          .string({
            required_error: t(
              'AUTHORIZATION.RESET_PASSWORD.PASSWORD.VALIDATION.REQUIRED'
            )
          })
          .trim()
          .min(8, {
            message: t(
              'AUTHORIZATION.RESET_PASSWORD.PASSWORD.VALIDATION.TOO_SHORT'
            )
          })
          .regex(/^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*\d).+$/, {
            message: t(
              'AUTHORIZATION.RESET_PASSWORD.PASSWORD.VALIDATION.INVALID'
            )
          }),
        confirm_password: z
          .string({
            required_error: t(
              'AUTHORIZATION.RESET_PASSWORD.CONFIRM_PASSWORD.VALIDATION.REQUIRED'
            )
          })
          .trim()
          .min(8, {
            message: t(
              'AUTHORIZATION.RESET_PASSWORD.CONFIRM_PASSWORD.VALIDATION.TOO_SHORT'
            )
          })
      })
      .refine(data => data.password === data.confirm_password, {
        message: t(
          'AUTHORIZATION.RESET_PASSWORD.CONFIRM_PASSWORD.VALIDATION.NOT_MATCH'
        ),
        path: ['confirm_password']
      }),
    onSubmit: (data: Record<string, any>) => {
      console.log('Form submitted:', data)
    }
  }
  return formConfig
}
